function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableflowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 781,
    viewBox: "0 0 1024 781",
    fill: "none",
    id: "svg14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M 791.47035,282.13512 H 212.11901 c -47.1922,0 -85.44939,39.1878 -85.44939,87.52951 v 42.01526 c 0,48.34171 38.25719,87.52952 85.44939,87.52952 h 579.35134 c 47.19249,0 85.44986,-39.18781 85.44986,-87.52952 v -42.01526 c 0,-48.34171 -38.25737,-87.52951 -85.44986,-87.52951 z",
    fill: "#067fec",
    id: "path1",
    style: {
      strokeWidth: 17.3139
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M 924.77964,557.85732 H 345.42998 c -47.19423,0 -85.45159,39.18954 -85.45159,87.52951 v 42.01529 c 0,48.34168 38.25736,87.52952 85.45159,87.52952 h 579.34966 c 47.19418,0 85.45166,-39.18784 85.45166,-87.52952 v -42.01529 c 0,-48.33997 -38.25748,-87.52951 -85.45166,-87.52951 z",
    fill: "#067fec",
    id: "path2",
    style: {
      strokeWidth: 17.3139
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 682.09334,5.5490815 H 102.74215 c -47.192701,0 -85.450053,39.1884955 -85.450053,87.5298475 v 42.014241 c 0,48.34067 38.257352,87.5302 85.450053,87.5302 h 579.35119 c 47.19252,0 85.44988,-39.18953 85.44988,-87.5302 V 93.078929 c 0,-48.341352 -38.25736,-87.5298475 -85.44988,-87.5298475 z",
    fill: "#067fec",
    id: "path3",
    style: {
      strokeWidth: 17.3139
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 541.95752,282.13512 H 212.11901 c -47.1922,0 -85.44939,39.1878 -85.44939,87.52951 v 42.01526 c 0,48.34171 38.25719,87.52952 85.44939,87.52952 h 329.83851 c 47.19251,0 85.44986,-39.18781 85.44986,-87.52952 v -42.01526 c 0,-48.34171 -38.25735,-87.52951 -85.44986,-87.52951 z",
    fill: "#067fec",
    id: "path4",
    style: {
      strokeWidth: 17.3139
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 424.89853,557.85732 h -79.46855 c -47.19423,0 -85.45159,39.18954 -85.45159,87.52951 v 42.01529 c 0,48.34168 38.25736,87.52952 85.45159,87.52952 h 79.46855 c 47.19253,0 85.44984,-39.18784 85.44984,-87.52952 v -42.01529 c 0,-48.33997 -38.25731,-87.52951 -85.44984,-87.52951 z",
    fill: "#067fec",
    id: "path5",
    style: {
      strokeWidth: 17.3139
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableflowIcon);
export default __webpack_public_path__ + "static/media/tableflow-icon.79cd4b17f19bbd0eb7ddefbf872ace73.svg";
export { ForwardRef as ReactComponent };